function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "lg1"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#43386b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7662bd"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientTransform: "matrix(-1 0 0 1 5497.018 0)",
  gradientUnits: "userSpaceOnUse",
  x1: 5318.21,
  x2: 5329.492,
  xlinkHref: "#lg1",
  y1: 398.515,
  y2: 378.975
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_2_",
  gradientTransform: "matrix(-1 0 0 1 5497.018 0)",
  gradientUnits: "userSpaceOnUse",
  x1: 5411.401,
  x2: 5422.683,
  xlinkHref: "#lg1",
  y1: 344.8,
  y2: 325.26
});

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 240.072,
  x2: 166.734,
  y1: 313.999,
  y2: 313.999
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e37a34"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffc538"
}));

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "lg2"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#dea861"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ebcba0"
}));

var _ref7 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 96.964,
  x2: 269.85,
  xlinkHref: "#lg2",
  y1: 151.283,
  y2: 251.099
});

var _ref8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 65.759,
  x2: 65.759,
  xlinkHref: "#lg1",
  y1: 411.667,
  y2: 312.669
});

var _ref9 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_6_",
  gradientUnits: "userSpaceOnUse",
  x1: 158.95,
  x2: 158.95,
  xlinkHref: "#lg1",
  y1: 465.383,
  y2: 366.384
});

var _ref10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_7_",
  gradientUnits: "userSpaceOnUse",
  x1: 323.639,
  x2: 358.833,
  y1: 391.133,
  y2: 391.133
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cc8241"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#dea861"
}));

var _ref11 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_8_",
  gradientUnits: "userSpaceOnUse",
  x1: 282.306,
  x2: 414.103,
  xlinkHref: "#lg2",
  y1: 234.58,
  y2: 310.673
});

var _ref12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m140.672 376.417 26.066-14.987.001.002c4.752-2.518 10.857-2.16 17.517 1.686 15.153 8.749 27.437 32.22 27.437 52.424 0 11.108-3.718 18.905-9.579 22.231l.004.009-25.027 14.407z",
  fill: "url(#SVGID_1_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m47.48 322.701 26.066-14.987.001.002c4.752-2.518 10.857-2.159 17.517 1.686 15.153 8.749 27.437 32.22 27.437 52.424 0 11.108-3.718 18.905-9.579 22.231l.004.009-25.027 14.407z",
  fill: "url(#SVGID_2_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m350.78 341.036v-128.783l-57.164 16.481-263.345-30.387v128.783c0 3.947 1.953 7.894 5.859 10.15l153.554 88.996c7.789 4.497 17.386 4.497 25.176 0l130.06-75.09c3.907-2.255 5.86-6.203 5.86-10.15z",
  fill: "url(#SVGID_3_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m344.92 317.243-130.06 75.091c-7.789 4.497-17.386 4.497-25.176 0l-153.554-88.996c-3.907-2.255-5.86-6.202-5.859-10.149v33.942c0 3.947 1.953 7.894 5.859 10.149l153.554 88.996c7.789 4.498 17.386 4.498 25.176 0l130.06-75.091c3.907-2.255 5.86-6.202 5.859-10.15v-33.942c.001 3.948-1.952 7.895-5.859 10.15z",
  fill: "#43386b"
}), /*#__PURE__*/React.createElement("path", {
  d: "m344.92 202.105-5.847-3.376-44.855 25.92-13.264-7.658-9.951-57.562-79.637-46.32c-7.789-4.497-17.386-4.497-25.176 0l-130.06 75.09c-7.812 4.51-7.812 15.787 0 20.297l153.554 88.996c7.789 4.497 17.386 4.497 25.176 0l130.06-75.091c7.813-4.51 7.813-15.786 0-20.296z",
  fill: "url(#SVGID_4_)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m38.321 344.693c0-20.204 12.284-29.491 27.437-20.742s27.437 32.22 27.437 52.424-12.284 29.491-27.437 20.742c-15.153-8.748-27.437-32.219-27.437-52.424z",
  fill: "url(#SVGID_5_)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 65.759,
  cy: 360.534,
  fill: "#e9e5f6",
  rx: 14.837,
  ry: 26.225,
  transform: "matrix(.92 -.392 .392 .92 -135.916 54.534)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m57.056 355.509c0-6.409 3.896-9.354 8.703-6.579 4.806 2.775 8.703 10.22 8.703 16.629s-3.896 9.354-8.703 6.579-8.703-10.22-8.703-16.629z",
  fill: "#7662bd"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m131.512 398.409c0-20.204 12.284-29.491 27.437-20.742s27.437 32.22 27.437 52.424-12.284 29.491-27.437 20.742-27.437-32.22-27.437-52.424z",
  fill: "url(#SVGID_6_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m141.867 404.387c0-12.579 7.648-18.361 17.083-12.914s17.083 20.06 17.083 32.64-7.648 18.361-17.083 12.914-17.083-20.06-17.083-32.64z",
  fill: "#e9e5f6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m150.247 409.225c0-6.409 3.896-9.354 8.703-6.579s8.703 10.22 8.703 16.629-3.896 9.354-8.703 6.579-8.703-10.22-8.703-16.629z",
  fill: "#7662bd"
})), /*#__PURE__*/React.createElement("path", {
  d: "m270.974 159.411-79.608-46.303c-7.789-4.497-17.386-4.497-25.176 0l-130.06 75.091c-7.812 4.51-7.812 15.787 0 20.297l74.688 43.463z",
  fill: "#ffa538"
}), /*#__PURE__*/React.createElement("path", {
  d: "m280.954 216.991-160.179 92.562 58.143 33.569v-51.845l10.766 6.216c7.789 4.497 17.386 4.497 25.176 0l102.763-59.33z",
  fill: "#7662bd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m120.775 309.552 160.179-92.561-9.956-57.593-160.179 92.561z",
  fill: "#43386b"
}), /*#__PURE__*/React.createElement("path", {
  d: "m344.92 202.105-5.847-3.376-160.155 92.547 10.766 6.216c7.789 4.497 17.386 4.497 25.176 0l130.06-75.091c7.813-4.51 7.813-15.786 0-20.296z",
  fill: "#ffa538"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m201.652 302.881c-5.814 0-10.957-4.179-11.978-10.104l-28.061-162.729-44.06-25.438-9.37 118.099c-.532 6.7-6.403 11.701-13.094 11.169-6.7-.531-11.7-6.394-11.169-13.094l10.895-137.313c.33-4.163 2.772-7.866 6.469-9.809 3.696-1.943 8.13-1.855 11.748.232l65.691 37.926c3.129 1.807 5.294 4.911 5.908 8.472l29.03 168.349c1.142 6.623-3.301 12.918-9.925 14.061-.701.121-1.397.179-2.084.179z",
  fill: "#594a8e"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m327.012 230.618c-5.814 0-10.957-4.179-11.978-10.104l-28.061-162.729-44.06-25.438-9.37 118.1c-.531 6.7-6.402 11.704-13.094 11.169-6.7-.532-11.7-6.394-11.169-13.094l10.895-137.314c.33-4.163 2.772-7.866 6.469-9.809 3.696-1.942 8.131-1.856 11.748.232l65.691 37.927c3.13 1.807 5.294 4.911 5.908 8.472l29.03 168.349c1.142 6.623-3.301 12.919-9.925 14.061-.701.119-1.397.178-2.084.178z",
  fill: "#594a8e"
})), /*#__PURE__*/React.createElement("path", {
  d: "m304.081 39.557-65.69-37.927c-3.763-2.172-8.399-2.174-12.163-.004l-125.36 72.264c-3.768 2.172-6.091 6.19-6.092 10.54-.001 4.349 2.318 8.369 6.085 10.544l65.691 37.926c1.883 1.087 3.983 1.63 6.085 1.63 2.098 0 4.197-.542 6.078-1.626l125.36-72.263c3.768-2.172 6.091-6.19 6.092-10.54.001-4.349-2.319-8.369-6.086-10.544zm-92.897 46.536-41.268-23.91 27.171-15.663 41.268 23.911zm-38.543 22.218-41.341-23.869 14.279-8.231 41.268 23.91zm90.051-51.91-41.268-23.911 10.878-6.27 41.342 23.869z",
  fill: "#7662bd"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m219.842 194.847c-4.212 0-8.307-2.189-10.559-6.101-3.352-5.825-1.348-13.266 4.478-16.618l116.915-67.282c5.825-3.351 13.265-1.348 16.619 4.478 3.352 5.826 1.348 13.266-4.478 16.618l-116.915 67.282c-1.914 1.099-4.002 1.623-6.06 1.623z",
  fill: "#7662bd"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m294.257 502.669c-2.065 0-4.157-.526-6.074-1.632l-74.438-42.977c-3.765-2.174-6.085-6.192-6.085-10.54v-314.102c0-6.721 5.448-12.17 12.17-12.17 6.721 0 12.17 5.448 12.17 12.17v307.076l68.353 39.464c5.821 3.361 7.815 10.804 4.455 16.624-2.254 3.904-6.345 6.087-10.551 6.087z",
  fill: "#7662bd"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m411.172 435.388c-2.065 0-4.157-.526-6.074-1.632l-74.438-42.977c-3.766-2.174-6.085-6.192-6.085-10.54v-314.103c0-6.721 5.448-12.17 12.17-12.17 6.721 0 12.17 5.448 12.17 12.17v307.077l68.353 39.464c5.821 3.361 7.815 10.804 4.455 16.625-2.254 3.903-6.345 6.086-10.551 6.086z",
  fill: "#7662bd"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m219.842 265.833c-4.206 0-8.296-2.183-10.551-6.087-3.36-5.821-1.366-13.264 4.455-16.625l116.915-67.501c5.821-3.357 13.263-1.367 16.624 4.455 3.36 5.821 1.366 13.264-4.455 16.625l-116.915 67.501c-1.916 1.106-4.009 1.632-6.073 1.632z",
  fill: "#7662bd"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m481.729 429.888v-159.621l-256.196 10.986v159.621c0 3.657 1.809 7.315 5.429 9.405l101.49 58.595c7.218 4.167 16.111 4.167 23.329 0l120.519-69.581c3.62-2.09 5.429-5.748 5.429-9.405z",
  fill: "url(#SVGID_7_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m230.962 271.849 120.519-69.581c7.218-4.167 16.111-4.167 23.329 0l101.49 58.595c7.239 4.18 7.239 14.629 0 18.808l-120.519 69.581c-7.218 4.167-16.111 4.167-23.329 0l-101.49-58.595c-7.239-4.18-7.239-14.629 0-18.808z",
  fill: "url(#SVGID_8_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m270.039 249.287 129.443 74.734 34.337-19.824-129.443-74.734z",
  fill: "#dea861"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#cc8241"
}, /*#__PURE__*/React.createElement("path", {
  d: "m290.562 237.429 129.443 74.733-6.726 3.884-129.443-74.734z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m399.482 324.021v28.357l34.337-19.825v-28.356z"
}))))));

var SvgForklift = function SvgForklift(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForklift, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/forklift.cdeceb53.svg";
export { ForwardRef as ReactComponent };